import type { UUIDString } from '@aigc/types';
import { css } from '@emotion/react';
import { useQuery } from '@tanstack/react-query';
import { Skeleton, Tag } from 'antd';
import { tagsQueryOptions } from '../api';

const SkeletonTag = () => {
  return (
    <Skeleton.Button
      css={css`
        --ant-control-height: 30px;
      `}
      active
      shape="round"
    ></Skeleton.Button>
  );
};

export const TagList = (props: {
  value?: UUIDString[];
  onChange?: (value: UUIDString[]) => void;
}) => {
  const { data, isLoading } = useQuery(tagsQueryOptions);

  return (
    <div className="flex items-center gap-2">
      {isLoading && (
        <>
          <SkeletonTag></SkeletonTag>
          <SkeletonTag></SkeletonTag>
          <SkeletonTag></SkeletonTag>
        </>
      )}
      {data?.length ? (
        <Tag.CheckableTagGroup
          classNames={{ item: 'text-lg' }}
          styles={{
            item: {
              '--ant-border-radius-sm': 'var(--ant-control-height)',
            },
          }}
          multiple
          options={data.map((item) => ({
            label: item.name,
            value: item.id,
          }))}
          value={props.value}
          onChange={props.onChange}
        ></Tag.CheckableTagGroup>
      ) : (
        '无'
      )}
    </div>
  );
};
